import { ref, watch } from '@vue/composition-api'

/**
 * Builds a pre-aggregated 2D array from already-loaded questionsAnswerCounts data.
 * No API call — data comes from the json-keys embed already fetched by useChartFilterOptions.
 *
 * Returns chartData: null | [["Total","Pregunta","Respuestas"], [count, q, a], ...]
 */
export function useProcessFormChart({ selectedQuestions, filterOptionsMap }) {
  const chartData = ref(null)

  const computeChartData = () => {
    if (!selectedQuestions.value.length) {
      chartData.value = null
      return
    }

    const entry = filterOptionsMap['question']
    const counts = entry?.questionsAnswerCounts || {}

    const rows = selectedQuestions.value.flatMap(q => {
      const answerCounts = counts[q] || {}
      return Object.entries(answerCounts).map(([answer, count]) => [count, q, answer])
    })

    chartData.value = rows.length > 0 ? [...rows] : null
  }

  watch(
    [selectedQuestions, () => filterOptionsMap['question']],
    computeChartData,
    { deep: true },
  )

  return { chartData }
}
